/**
 * Funcao que recupera o height computado
 * do header da tabela
 * @param node Elemento header da tabela
 */
const computHeaderSize = (node) => {
  if (!node) return;

  const headerComputedHeight = window.getComputedStyle(node, null).height;
  return headerComputedHeight;
};

/**
 * @param {*} node elemento que possui o tamanho da tabela
 * @param {*} data dados do cruzamento simples
 * @param {*} perguntaWidthScale qual porcentagem da tabela sera dedicada para a pergunta inicialmente
 * @param {*} characterSize taxa de conversao de 1 caracter para pixels de width
 * @param {*} alternativaMinWidth valor minimo de width q uma alternativa deve possuir
 * @param {*} ghostWidth valor de width a ser usado em consideracao, pode ser a soma de width de intens da tela q n percentem ao atributo data
 */
const computTableSize = (node, data, perguntaWidthScale, characterSize, alternativaMinWidth, ghostWidth) => {
  if (!node || !data || !data.perguntas_principais) return;

  const tableWidth = window.getComputedStyle(node, null).width.replace('px', '');
  const perguntaStartWidth = tableWidth * perguntaWidthScale;

  let alternativasWidthNumber = data.perguntas_principais[0].alternativas.map((alternativa) => {
    const alternativaCaracteres = alternativa.enunciado.length;
    const alternativaWidth = alternativaCaracteres * characterSize;
    return alternativaWidth < alternativaMinWidth ? alternativaMinWidth : alternativaWidth;
  });

  /**
     * Valor inicial da pergunta
     */
  let perguntaWidthNumber = perguntaStartWidth;


  const getTotalWidthAlternativas = () => alternativasWidthNumber.reduce((prev, next) => prev + next);
  while ((perguntaWidthNumber + getTotalWidthAlternativas() + ghostWidth) < tableWidth) {
    ++perguntaWidthNumber;
    alternativasWidthNumber = alternativasWidthNumber.map((value) => ++value);
  }

  /**
     * Convertendo widths para px string
     */
  const perguntaWidth = `${perguntaWidthNumber}px`;
  const alternativasWidth = alternativasWidthNumber.map((number) => `${number}px`);

  return {
    perguntaWidth,
    alternativasWidth,
  };
};

const headerStyleHander = {
  computHeaderSize, computTableSize,
};

export default headerStyleHander;
